import { useState, useEffect } from 'react';
import { LAW_TITLES as DEFAULT_TITLES } from '../lib/lawTitles';

// Cache the promise to prevent multiple fetches
let titlesPromise: Promise<Record<string, string>> | null = null;
let cachedTitles: Record<string, string> | null = null;

export const useLawTitles = () => {
    const [titles, setTitles] = useState<Record<string, string>>(cachedTitles || DEFAULT_TITLES);
    const [loading, setLoading] = useState(!cachedTitles);

    useEffect(() => {
        if (cachedTitles) {
            setLoading(false);
            return;
        }

        if (!titlesPromise) {
            titlesPromise = fetch('/api/filters/metadata')
                .then(res => {
                    if (!res.ok) throw new Error('Failed to fetch metadata');
                    return res.json();
                })
                .then(data => {
                    cachedTitles = { ...DEFAULT_TITLES, ...data.law_titles };
                    return cachedTitles!;
                })
                .catch(err => {
                    console.error('Error loading law titles:', err);
                    // Fallback to defaults
                    return DEFAULT_TITLES;
                });
        }

        titlesPromise.then(finalTitles => {
            setTitles(finalTitles);
            setLoading(false);
        });
    }, []);

    const getTitle = (key: string): string => {
        return titles[key] || titles[key.replace(/_/g, ' ')] || key;
    };

    return { titles, getTitle, loading };
};
